import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { MomentModule } from 'angular2-moment';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

//Modules
import { routing, appRoutingProviders } from './app.routes';
import { CustErrorHandler } from './app.error.handler';
import { ClipboardModule }  from 'ngx-clipboard';
import { CustomHttpInterceptor }  from './app.interceptor';
import { DropdownModule } from 'ngx-dropdown';

import { MapsSearchModule } from './modules/maps-search/maps-search.module';
import { MapsSidebarModule } from './modules/maps-sidebar/maps-sidebar.module';
import { MapsAddStuffModule } from './modules/maps-add-stuff/maps-add-stuff.module';
import { SigninSignupModule } from './modules/signin-signup/signin-signup.module';
import { TermsConditionModule } from './modules/terms-condition/terms-condition.module';
//Guards
import { PopupGuard } from './guards/index';

//Directives
import { FORMATPHONENUMBER_DIRECTIVES } from './directives/format_phone_number/index';

//Services
import { BaseService } from './services/base.service';
import { PopupService } from './services/popup.service';
import { MapService } from './services/map.service';
import { RetailerService } from './services/retailer.service';
import { UserService } from './services/user.service';
import { NotificationService } from './services/notification.service';
import { MyStuffService } from './services/my-stuff.service';
import { PinService } from './services/pin.service';
import { PropertyService } from './services/property.service';
import { LoaderService } from './services/loader.service';
import { RemovedItemsService } from './services/removed-items.service';
import { BrandingService } from './services/branding.service';
import { SegmentService } from './services/segment.service';
import { FeatureService } from './services/feature.service';
import { PrintService } from './services/print.service';

// 3rd party
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

//Components
import {
  MarqetmapAppComponent,
  MapComponent,
  HeaderComponent,
  SaveMapComponent,
  ShareMapComponent,
  MyStuffComponent,
  NotificationComponent,
  NotificationItemComponent,
  ProfileComponent,
  ForgotPasswordComponent,
  PasswordResetComponent,
  UserMapComponent,
  MapsAllComponent,
  MapsReceivedComponent,
  MapsSharedComponent,
  MapsSectionComponent,
  RetailerSectionComponent,
  PropertySectionComponent,
  PinSectionComponent,
  ShareEmailComponent,
  ShareEmbedComponent,
  ShareLinkComponent,
  RemovedItemsComponent,
  RemovedPinsComponent,
  RemovedPropertiesComponent,
  RemovedRetailersComponent,
  RemovedMapsComponent,
  ContactSupportComponent,
  PopupComponent,
  AllRemovedItemsComponent,
  MastermapWarningComponent,
  AppSwitcherComponent,
  MobileUserOptionsComponent,
  PrintComponent,
  DemographicReportComponent,
  HomeComponent,
  ModifiedByComponent,
  UserEmailVerificationComponent
} from './components/index';

@NgModule({
  declarations: [
    AppComponent,
    MarqetmapAppComponent,
    MapComponent,
    HeaderComponent,
    SaveMapComponent,
    ShareMapComponent,
    MyStuffComponent,
    NotificationComponent,
    NotificationItemComponent,
    UserMapComponent,
    ProfileComponent,
    ForgotPasswordComponent,
    PasswordResetComponent,
    MapsAllComponent,
    MapsReceivedComponent,
    MapsSharedComponent,
    MapsSectionComponent,
    RetailerSectionComponent,
    PinSectionComponent,
    PropertySectionComponent,
    ShareEmailComponent, 
    ShareEmbedComponent,
    ShareLinkComponent,
    RemovedItemsComponent,
    RemovedPinsComponent,
    RemovedPropertiesComponent,
    RemovedRetailersComponent,
    RemovedMapsComponent,
    ContactSupportComponent,
    AllRemovedItemsComponent,
    MastermapWarningComponent,
    PopupComponent,
    AppSwitcherComponent,
    MobileUserOptionsComponent,
    PrintComponent,

    /* Directives */
    FORMATPHONENUMBER_DIRECTIVES,

    ModifiedByComponent,

    DemographicReportComponent,

    HomeComponent,

    UserEmailVerificationComponent,

    /*Pipes*/
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    routing,
    ReactiveFormsModule,
    CommonModule,
    PerfectScrollbarModule,
    ClipboardModule,
    MomentModule,
    MapsSearchModule,
    MapsSidebarModule,
    MapsAddStuffModule,
    SigninSignupModule,
    TermsConditionModule,
    BrowserAnimationsModule,
    DropdownModule
  ],
  providers: [
    BaseService,
    PopupService,
    UserService,
    NotificationService,
    RetailerService,
    PropertyService,
    MapService,
    PinService,
    MyStuffService,
    RemovedItemsService,
    appRoutingProviders,
    FeatureService,
    LoaderService,
    PopupGuard,
    BrandingService,
    SegmentService,
    PrintService,
    { provide: ErrorHandler, useClass: CustErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: CustomHttpInterceptor, multi: true },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts